import { render, staticRenderFns } from "./CartaoObservacao.vue?vue&type=template&id=5527dc72&scoped=true"
import script from "./CartaoObservacao.vue?vue&type=script&lang=js"
export * from "./CartaoObservacao.vue?vue&type=script&lang=js"
import style0 from "./CartaoObservacao.vue?vue&type=style&index=0&id=5527dc72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5527dc72",
  null
  
)

export default component.exports